import React, { useContext, useState } from 'react'
import { useNavigate } from "react-router-dom"
import {
    AppBar,
    Box,
    CssBaseline,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Toolbar,
    Button,
    Avatar,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

import { AppContext } from '././../../context/context/context.js'

import logo from "../../assets/logo.png"

const drawerWidth = 240

const DrawerAppBar = (props) => {
    const { window } = props
    const [mobileOpen, setMobileOpen] = useState(false)
    const { state } = useContext(AppContext)
    const navigate = useNavigate()

    const handleDrawerToggle = () => setMobileOpen((prevState) => !prevState)

    const container = window !== undefined ? () => window().document.body : undefined

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', }}>
            <Box sx={{ p: 2, textAlign: '-webkit-center' }}>
                <Avatar
                    src={logo}
                    alt='Youssef'
                    onClick={() => navigate('/')}
                    sx={{ cursor: 'pointer' }}
                />
            </Box>
            <Divider sx={{ bgcolor: state.color.secondary, }} />
            <List>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate(`/`)}
                        sx={{
                            fontFamily: "League Gothic, sans-serif",
                            fontSize: { xs: 22, md: 26 },
                            color: state.color.secondary,
                            textAlign: 'center',
                            '&:hover': {
                                color: state.color.light,
                                bgcolor: state.color.active
                            },
                        }}
                    >
                        <ListItemText primary={"ABOUT ME"} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate(`/mywork`)}
                        sx={{
                            fontFamily: "League Gothic, sans-serif",
                            fontSize: { xs: 22, md: 26 },
                            color: state.color.secondary,
                            textAlign: 'center',
                            '&:hover': {
                                color: state.color.light,
                                bgcolor: state.color.active
                            },
                        }}
                    >
                        <ListItemText primary={"MY WORK"} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => navigate('/contact')}
                        sx={{
                            fontFamily: "League Gothic, sans-serif",
                            fontSize: { xs: 22, md: 26 },
                            color: state.color.secondary,
                            textAlign: 'center',
                            '&:hover': {
                                color: state.color.light,
                                bgcolor: state.color.active
                            },
                        }}
                    >
                        <ListItemText primary={"CONTACT ME"} />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box >
    )

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                component="nav"
                sx={{
                    bgcolor: state.color.primary,
                    py: '0.75%',
                }}
            >
                <Toolbar sx={{ justifyContent: { sm: 'space-between' } }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ p: 2, textAlign: '-webkit-center' }}>
                        <Avatar
                            src={logo}
                            alt='Youssef'
                            onClick={() => navigate('/')}
                            sx={{ cursor: 'pointer' }}
                        />
                    </Box>
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <Button
                            onClick={() => navigate(`/`)}
                            sx={{
                                fontFamily: "League Gothic, sans-serif",
                                fontSize: { xs: 22, md: 26 },
                                color: state.color.secondary,
                                '&:hover': { color: state.color.light, },
                            }}
                        >
                            ABOUT ME
                        </Button>
                        <Button
                            onClick={() => navigate(`/mywork`)}
                            sx={{
                                fontFamily: "League Gothic, sans-serif",
                                fontSize: { xs: 22, md: 26 },
                                color: state.color.secondary,
                                '&:hover': { color: state.color.light, },
                            }}
                        >
                            MY WORK
                        </Button>
                        <Button
                            onClick={() => navigate('/contact')}
                            sx={{
                                fontFamily: "League Gothic, sans-serif",
                                fontSize: { xs: 22, md: 26 },
                                color: state.color.secondary,
                                '&:hover': { color: state.color.light, },
                            }}
                        >
                            CONTACT ME
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: drawerWidth,
                            color: state.color.primary,
                            bgcolor: state.color.primary,
                            boxShadow: `0px 0px 15px 0px ${state.color.primary}`,
                        },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
        </Box>
    )
}

export default DrawerAppBar
